import { IconButton } from "@mui/material";
import React from "react";
// import { default as hotToast, Toast } from "react-hot-toast";
import { IoMdClose } from "@react-icons/all-files/io/IoMdClose";
import styles from "./useHotToast.module.scss";
import { toast as toastify } from "react-toastify";

const toastifyTypeMap = {
  default: "info",
  success: "success",
  error: "error",
};

const useHotToast = () => {
  const toast = (props: {
    message: string;
    type: "default" | "error" | "success";
  }) => {
    toastify(props.message, {
      type: toastifyTypeMap[props.type] as any,
    });
  };

  return toast;
};

export default useHotToast;
